import React from 'react';
import {Link} from 'react-router-dom';
import tealImage from '@/assets/featured-dashboard-phone.jpg';

const FeaturedCard: React.FC = () => {
    return (
        <div className="col-span-1 sm:col-span-2 lg:col-span-2 bg-mld-menu-text rounded-xl overflow-hidden">
            {/* Teal image inlaid inside the dark box with padding so dark bg frames it */}
            <div className="px-4 pt-4">
                <img
                    src={tealImage}
                    alt="Baseline Health — No nonsense health insights. Developed by lab care experts."
                    className="w-full rounded-lg"
                />
            </div>

            {/* Bottom — text + button on the dark background below the image */}
            <div className="flex items-center justify-between gap-4 px-8 py-5">
                <p className="text-mld-muted-text/60 text-sm leading-snug">
                    18 Biomarkers that tell the complete story of your whole body health.
                    <br />
                    The best solution to unlocking the secret to better health.
                </p>
                <Link
                    to="/dashboard"
                    className="flex-shrink-0 px-5 py-2.5 text-sm font-semibold bg-mld-primary text-white rounded-lg hover:bg-mld-primary/90 transition-colors">
                    Learn More
                </Link>
            </div>
        </div>
    );
};

export default FeaturedCard;
